import * as yup from 'yup';

const textFieldRegexp = /^([a-zA-Z]{0,30})$/;
const emailRegexp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const reportsFormSchema = yup.object().shape({
  firstName: yup.string().matches(textFieldRegexp, 'Incorrect field').required('Required field'),
  lastName: yup.string().matches(textFieldRegexp, 'Incorrect field').required('Required field'),
  companyName: yup.string().required('Required field'),
  email: yup.string().matches(emailRegexp, 'Incorrect email').required('Required field'),
});

export type ReportsFormValues = {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
};
